import { TranslationRepository } from '../data/translation-repository';
import { ApplicationType, BulkImportValidateResponse } from '../types/translation-types';

export class ValidateBulkImportUseCase {
  constructor(private readonly repository: TranslationRepository) {}

  async execute(
    applicationType: ApplicationType,
    file: File
  ): Promise<BulkImportValidateResponse> {
    return this.repository.validateBulkImport(applicationType, file);
  }
}
